var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyCow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.446,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300.446,
    id: "screenshot-e97d6340-1ad2-806c-8002-8eb126a3ac3a",
    viewBox: "-0.223 -0.223 300.446 300.446",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-e97d6340-1ad2-806c-8002-8eb126a3ac3a",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-e97d6340-1ad2-806c-8002-8eb126a481a9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-e97d6340-1ad2-806c-8002-8eb126a481a9"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M150.269,275.000C133.033,275.025,116.830,271.768,101.661,265.228C86.491,258.688,73.221,249.750,61.850,238.412C50.479,227.075,41.501,213.824,34.916,198.658C28.331,183.493,25.026,167.283,25.000,150.030C24.974,132.776,28.231,116.556,34.771,101.372C41.311,86.187,50.250,72.961,61.587,61.694C72.925,50.427,86.176,41.501,101.342,34.916C116.507,28.331,132.717,25.026,149.970,25.000C167.224,24.974,183.444,28.231,198.628,34.771C213.813,41.311,227.039,50.198,238.306,61.431C249.573,72.664,258.499,85.880,265.084,101.079C271.669,116.277,274.974,132.495,275.000,149.731C275.025,166.967,271.768,183.170,265.228,198.339C258.688,213.509,249.802,226.760,238.569,238.092C227.335,249.425,214.120,258.403,198.921,265.026C183.723,271.650,167.505,274.974,150.269,275.000ZL150.269,275.000ZM150.314,256.250C179.793,256.206,204.830,245.804,225.424,225.044C246.018,204.284,256.293,179.165,256.250,149.686C256.206,120.207,245.876,95.170,225.259,74.576C204.643,53.981,179.503,43.706,149.842,43.750C120.467,43.794,95.430,54.124,74.732,74.741C54.033,95.357,43.706,120.497,43.750,150.158C43.794,179.533,54.196,204.570,74.956,225.268C95.716,245.966,120.835,256.293,150.314,256.250ZL150.314,256.250Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d18e9d856"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d18e9d856"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M151.777,211.777C151.777,211.777,175.777,211.777,178.920,198.276C178.920,198.276,181.777,185.777,173.834,182.901L184.006,144.464C184.006,144.464,217.063,157.276,229.777,131.652C229.777,131.652,211.977,108.590,186.549,129.089C186.549,129.089,199.263,103.465,181.463,95.777C181.463,95.777,184.006,121.402,173.834,121.402C163.663,121.402,170.812,118.550,163.777,116.777C157.250,115.133,148.777,115.777,148.777,115.777",
    style: {
      fill: "rgb(232, 233, 234)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d18e9d856",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M151.777,211.777C151.777,211.777,175.777,211.777,178.920,198.276C178.920,198.276,181.777,185.777,173.834,182.901L184.006,144.464C184.006,144.464,217.063,157.276,229.777,131.652C229.777,131.652,211.977,108.590,186.549,129.089C186.549,129.089,199.263,103.465,181.463,95.777C181.463,95.777,184.006,121.402,173.834,121.402C163.663,121.402,170.812,118.550,163.777,116.777C157.250,115.133,148.777,115.777,148.777,115.777",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d18e9d857"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d18e9d857"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M147.777,211.777C147.777,211.777,123.777,211.777,120.634,198.276C120.634,198.276,117.777,185.777,125.720,182.901L115.549,144.464C115.549,144.464,82.491,157.276,69.777,131.652C69.777,131.652,87.577,108.590,113.006,129.089C113.006,129.089,100.291,103.465,118.091,95.777C118.091,95.777,115.549,121.402,125.720,121.402C135.891,121.402,128.742,118.550,135.777,116.777C142.304,115.133,150.777,115.777,150.777,115.777",
    style: {
      fill: "rgb(232, 233, 234)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d18e9d857",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M147.777,211.777C147.777,211.777,123.777,211.777,120.634,198.276C120.634,198.276,117.777,185.777,125.720,182.901L115.549,144.464C115.549,144.464,82.491,157.276,69.777,131.652C69.777,131.652,87.577,108.590,113.006,129.089C113.006,129.089,100.291,103.465,118.091,95.777C118.091,95.777,115.549,121.402,125.720,121.402C135.891,121.402,128.742,118.550,135.777,116.777C142.304,115.133,150.777,115.777,150.777,115.777",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCow);
export default __webpack_public_path__ + "static/media/grey_cow.716e06dfceccc947c4b4b8abe4e6d67c.svg";
export { ForwardRef as ReactComponent };